import { render, staticRenderFns } from "./imgShow.vue?vue&type=template&id=5a9c0f78&scoped=true&"
import script from "./imgShow.vue?vue&type=script&lang=js&"
export * from "./imgShow.vue?vue&type=script&lang=js&"
import style0 from "./imgShow.vue?vue&type=style&index=0&id=5a9c0f78&prod&lang=stylus&scoped=true&"
import style1 from "./imgShow.vue?vue&type=style&index=1&id=5a9c0f78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9c0f78",
  null
  
)

export default component.exports